module.exports = __webpack_public_path__ + "static/engineering-at-google-785428dc6379ab5398daf90fa456ce5d.jpg";